import Btn from "@/components/Btn";
import CustomLabel from "@/components/CustomLabel";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Input } from "@progress/kendo-react-inputs";
import React, { useEffect, useState } from "react";

interface IProps {
  setShowDialog: React.Dispatch<React.SetStateAction<boolean>>;
  onNameSave: (name: string) => void;
  initialName?: string;
}

function NameDialog({ setShowDialog, onNameSave, initialName = "" }: IProps) {
  const [name, setName] = useState<string>(initialName);

  useEffect(() => {
    setName(initialName);
  }, [initialName]);

  return (
    <Dialog width={450} title={"Area Name"} onClose={() => setShowDialog(false)} className="custom-dialog">
      <div className="mb-4">
        <CustomLabel label={"Name"} required={true} />
        <Input
          type="text"
          placeholder={"Enter Name"}
          value={name}
          onChange={(e: any) => {
            setName(e.target.value);
          }}
        />
      </div>
      <DialogActionsBar>
        <div className="flex justify-end gap-3">
        <div className="w-[86px] h-[34px]">
            <Btn variant="tertiary" text={"Cancel"} border disabled={false} onClick={() => setShowDialog(false)} />
        </div>
        <div className="w-[86px] h-[34px]">
          <Btn variant="primary" disabled={!name} text={"Confirm"} onClick={() => onNameSave(name)} />
        </div>
        </div>
      </DialogActionsBar>
    </Dialog>
  );
}

export default NameDialog;